import { render, staticRenderFns } from "./PrintLabelButton.vue?vue&type=template&id=2d3c3308&scoped=true"
import script from "./PrintLabelButton.vue?vue&type=script&lang=js"
export * from "./PrintLabelButton.vue?vue&type=script&lang=js"
import style0 from "./PrintLabelButton.vue?vue&type=style&index=0&id=2d3c3308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c3308",
  null
  
)

export default component.exports